import { Controller } from "stimulus"

export default class PricingController extends Controller {

  static get targets() {
    return [
      'monthlyPrice', 'monthly', 'yearly', 'mtoggle', 'ytoggle', 'peruser', 'section'
    ]
  }

  urlBase = window.jekyllEnv === 'production' ? 'https://app.beekeeperstudio.io' : 'http://localhost:3000'

  isMonthly = false

  initialize() {

    this.render()

  }

  render() {
    const yDisplay = this.isMonthly ? 'none' : ''
    const mDisplay = this.isMonthly ? '' : 'none'

    if (this.isMonthly) {

      // this.monthlypriceTargets.forEach(t => t.classList.remove('strikethrough'))

      this.mtoggleTarget.classList.add('active')
      this.ytoggleTarget.classList.remove('active')

      this.sectionTarget.classList.add('monthly')
      this.sectionTarget.classList.remove('yearly')
      this.monthlyPriceTargets.forEach((t) => t.classList.remove('strikethrough'))
    } else {

      // this.monthlypriceTargets.forEach(t => t.classList.add('strikethrough'))
      this.ytoggleTarget.classList.add('active')
      this.mtoggleTarget.classList.remove('active')

      this.sectionTarget.classList.add('yearly')
      this.sectionTarget.classList.remove('monthly')
      this.monthlyPriceTargets.forEach((t) => t.classList.add('strikethrough'))
    }

    this.monthlyTargets.forEach((target) => {
      target.style.display = mDisplay;
    })
    this.yearlyTargets.forEach((target) => {
      target.style.display = yDisplay;
    })

    

  }

  toggle(event) {
    this.isMonthly = !this.isMonthly
    this.render()
  }


}
